import React from "react";
import { Header } from "semantic-ui-react";
import "../../../styles/lms/lms-table.scss";

const LmsFormWarningTitle = ({ message }) => {
  return <Header size="small" color="red" textAlign="center" className="lms-form-top-header">{message}</Header>;
};

export default LmsFormWarningTitle;